export const MADA_CARD_BINS = [
  440647, 440795, 446404, 457865, 588845, 968208, 457997, 474491, 421141,
  417633, 468540, 468541, 468542, 468543, 446393, 636120, 968201, 409201,
  410621, 403024, 458456, 484783, 462220, 455708, 968205, 455036, 486094,
  486095, 486096, 588848, 968203, 440533, 489318, 489319, 445564, 504300,
  968211, 410685, 406996, 432328, 428671, 428672, 428673, 446672, 543357,
  434107, 407197, 407395, 412565, 968206, 431361, 521076, 604906, 588850,
  529415, 535825, 543085, 524130, 554180, 549760, 968202, 22337902, 22337986,
  516138, 515079, 555610, 524514, 529741, 537767, 535989, 536023, 513213,
  520058, 968209, 558563, 605141, 422817, 422818, 422819, 428331, 968204,
  410834, 406136, 589206, 483010, 483011, 483012, 968207, 407520, 439954,
  419593, 530060, 531196, 420132, 242030, 22402030, 52166100, 442463, 45488707,
  49098000, 40545400, 968203, 504300, 440533, 489318, 489319, 445564, 968211,
  410685, 406996, 432328, 428671, 428672, 428673, 968206, 446672, 543357,
  434107, 40719700, 40739500, 412565, 431361, 604906, 521076, 588850, 968202,
  529415, 535825, 543085, 524130, 554180, 549760, 22337902, 22337986, 516138,
  515079, 555610, 968209, 524514, 529741, 537767, 535989, 536023, 513213,
  520058, 558563, 968204, 422817, 422818, 422819, 410834, 428331, 483010,
  483011, 483012, 589206, 968207, 406136, 419593, 439954, 407520, 53973776,
  530060, 531196, 420132, 242030, 52166100, 22402030, 442463, 524940, 442429,
];
export const OMAN_NET_CARD_BINS = [
  419244, 426371, 426372, 404747, 44661696, 42404433, 43382962, 43382963,
  43382964, 43382999, 46442605, 48909105, 48417205, 43323605, 40402905,
  52904219, 52904235, 52904245, 52904215, 53211381, 48379130, 48379131,
  48379132, 48379133, 48379134, 48379135, 48379136, 48379137, 48379138,
  48379139, 48379140, 48379141, 48379145, 48379150, 48379151, 48379152,
  48379153, 48379154, 48379155, 48379156, 48379157, 48379158, 48379159,
  42282130, 42282131, 42282132, 42282150, 42282151, 42282152, 42282153,
  42282154, 42282155, 42282156, 42282157, 42282158, 42282159, 42282230,
  42282030, 42282031, 42282032, 42282033, 42282034, 42282050, 42282051,
  42282052, 42282053, 42282054, 42282055, 42282056, 42282057, 42282058,
  42282059, 44716830, 44716831, 44716832, 44716850, 44716899, 40754520,
  40754521, 40754530, 40754531, 40754532, 40754533, 40754534, 40754535,
  40754536, 40754537, 40754538, 40754539, 40754540, 40754541, 40754542,
  40754543, 40754544, 40754545, 40754546, 40754547, 40754548, 40754549,
  40754550, 40754551, 40754552, 40754553, 40754554, 40754555, 40754556,
  40754557, 40754558, 40754559, 43663755, 46395255, 464156, 464157, 416370,
  484130, 484131, 47971022, 47971023, 44747774, 44747978, 44747977, 43347833,
  43935700, 432410, 432415, 433084, 422610, 473820, 510723, 515722, 523672,
  534417, 539150, 549184, 534227, 539188, 549131, 539540, 55592070, 42136060,
  42147814, 419291, 44661697, 43909703, 46736200, 46736201, 43909701, 41329805,
  47429505, 53493348, 53610985, 53610939, 410469, 536028, 559753, 42825700,
  47518400, 42268100, 46046800, 42282330, 42282331, 42282332, 42282333,
  42282334, 42282350, 42282351, 42282352, 42282353, 42282354, 46417530,
  46417531, 46417550, 46417551, 601722, 40277200, 49506645, 43935701,
];
export const MAAL_CARD_BINS = [
  66905401, 66905495, 66905422, 66905436, 66905437, 66905438, 66905439, 66905440,
  66905457, 66905460, 66905492, 66905471, 66905485, 66905450, 66905451, 66905452,
  66905453, 66905454, 66905478, 66905408, 66905429, 66905464, 66905415, 66905418,
  66905416, 66905443, 66905496, 95126650, 95126630, 95126655, 95126651, 95126639,
  95126670, 95126629, 95126620,
];
export const CARD_TYPES = {
  AMEX: 'american-express',
  OMAN: 'omannet',
  MAAL: 'maalcard',
};
export const CARD_LENGTH = 16;
export const AMEX_CARD_LENGTH = 15;
export const CARD_NUMBER_SPACES = 3;
export const EXPIRY_DATE_LENGTH = 5;
export const CVV_LENGTH = 3;
export const AMEX_CVV_LENGTH = 4;
export const CARD_HOLDER_NAME_MAX_LENGTH = 24;

export const borderStyleConstants = {
  ROUNDED: 'ROUNDED',
  RECTANGULAR: 'RECTANGULAR'
}

export const PAYMENT_METHODS_TYPES = {
  MOTO: 'moto',
  ONLINE: 'online',
};

export const SAVED_CARD_TYPES = {
  VISA: 'VISA',
  MASTER_CARD: 'MASTERCARD',
  AMEX: 'AMEX',
  MAESTRO: 'MAESTRO',
  MEEZA: 'MEEZA',
  MADA: 'MADA',
  OMAN_NET: 'OMANNET',
  MAAL_CARD: 'MAAL',
  JCB: 'JCB',
};
